import { DesignerInterface, Layout, ResourceFileProps, serializeComponents, TabProps } from "@mcleod/components";
import { LayoutDesignerTab } from "@mcleod/designer";
import { AppDesignerMode } from "../AppDesignerMode";

export class AppLayoutDesignerTab extends LayoutDesignerTab {
    private designMode: AppDesignerMode;
    compatLayout: Layout;
    componentAppPropMap: Map<string, any> = new Map<string, any>();

    constructor(designer: DesignerInterface, props: ResourceFileProps, tabProps?: Partial<TabProps>) {
        super(designer, props, tabProps);
        if (props.path == null) {
            // A new tab has been opened to start designing in any empty layout.
            this.designMode = AppDesignerMode.APP_DESIGN;
            this.designerPanel.setProps({ designedForMobile: true });
        } else {
            this.designMode = AppDesignerMode.APP_COMPAT;
        }
    }

    override updateFromServerResponse(serverResponse: any) {
        super.updateFromServerResponse(serverResponse);
        if (this.definition != null && this.definition.designedForMobile === true) {
            this.designMode = AppDesignerMode.APP_DESIGN;
        }
    }

    public getDesignMode(): AppDesignerMode {
        return this.designMode;
    }

    public override getSerializedDesignerLayout(): string {
        if (AppDesignerMode.APP_COMPAT === this.designMode) {
            return serializeComponents(this.compatLayout, this.dataSources);
        } else {
            return serializeComponents(this.designerPanel, this.dataSources);
        }
    }
}
